module.exports = __webpack_public_path__ + "static/media/astanaguide.8be5344b.png";